// Product Style List
import React from 'react';
import PropTypes from 'prop-types';
import ProductStyleListItem from './ProductStyleListItem';

const ProductStyleList = ({ productStyles }) => (
  <div>
    <div className="fw-bold fs-lg">{productStyles.length} Results</div>
    <div className="product-link-list productstyle-list">
      {productStyles.map(item => <ProductStyleListItem key={item.id} productstyle={item} />)}
    </div>
  </div>
);

ProductStyleList.propTypes = {
  productStyles: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  })),
};

export default ProductStyleList;
